import SourceFlowText from "@sourceflow-uk/sourceflowtext";
import jobsSector from "../../.sourceflow/jobs-Sectors.json";
import ukjobsType from "../../.sourceflow/jobs-job_types.json";
import ukjobsWorkType from "../../.sourceflow/jobs-work_type.json";
import jobsLocation from "../../.sourceflow/jobs-job_locations.json"
import ukbasesalaryrange from "../../.sourceflow/jobs-uk_base_salary_range.json";
import featuredEmployers from "../../.sourceflow/jobs-featured_employers.json";
import businessectors from "../../.sourceflow/jobs-business_solutions_sectors.json"
import { Container, Col, Row } from 'reactstrap';
import styles from './styles.module.scss';
import React from "react";
import JobSearch from "@sourceflow-uk/job-search";
import "@sourceflow-uk/job-search/dist/bundle.css";
import JobsCard from "/components/JobsCard";
import Form from "@/components/Shared/Form";

export default function AllJobSearch({
    global,
    pathPrefix,
    customClass = "",
    internalJob = false,
    jobClientFilter = false,
    locale = "",
    newsletter_content,
    formId,
    successPageUrl,
    client_cat_value,
    sectionID
}) {
    return (
        <>
            <section className={`${styles.root} ${customClass} ${internalJob ? "internal-jobs" : ""}`} id={`${sectionID}`}>
                <Container>
                    {internalJob ?
                        <JobSearch
                            translations={{
                                "button.text": "Search",
                                "input.placeHolder": "Search by location/job title",
                                "input.locationPlaceholder": "Location",
                            }}
                            options={{
                                jobsPerPage: 12,
                                searchFilters: true,
                                submitDestination: null,
                                performInitialSearch: true,
                                searchSubmitButton: true,
                                searchInput: {
                                    queryInput: true,
                                    locationInput: false,
                                    radiusInput: false,
                                    radiusOptions: {
                                        units: "kilometres"
                                    }
                                },
                                searchFiltersOptions: {
                                    topLevelCategoryOrder: ["jobSectors", "Salary", "Job Type"],
                                    filterShowCount: false,
                                    exclude: {
                                        // Internal Job
                                        'ee19575c-07f3-4869-8ef1-f90262ae380e': true,
                                        // Consultants
                                        Consultants: true,
                                        Country: true,
                                        '3d5bec36-c55b-4f99-a149-d5931658df26': true,
                                        'f46a3886-58ed-463b-83ab-7e682fee8ee6': true,
                                    }
                                },
                                searchResults: ({ results }) =>
                                    results?.length >= 1 ?
                                        <>
                                            <Row>
                                                {results.map(({ job, index }) => (
                                                    <Col lg={6} xl={4} key={index} className="mb-4">
                                                        <JobsCard
                                                            post_lang={locale}
                                                            {...job} />
                                                    </Col>
                                                ))}
                                            </Row>
                                        </>
                                        : <><ld-slot name="Find a job - No results found" ></ld-slot></>
                            }
                            }
                        />
                        :
                        jobClientFilter ?
                            <JobSearch
                                translations={{
                                    "button.text": "Search",
                                    "input.placeHolder": "Search by location/job title",
                                    "input.locationPlaceholder": "Location",
                                }}
                                options={{
                                    urlFilters: {
                                        mode: "active",
                                        jobCategories: [
                                            jobsSector,
                                            ukjobsType,
                                            jobsLocation,
                                            featuredEmployers,
                                            ukjobsWorkType,
                                        ],
                                        pushToHistoryOnSearch: true,
                                        changeURLOnFilterChange: true,
                                    },
                                    jobsUrl: `${locale === "/us" ? "/us" : ""}/jobs`,
                                    jobsPerPage: 9,
                                    searchFilters: true,
                                    submitDestination: null,
                                    performInitialSearch: true,
                                    searchSubmitButton: false,
                                    searchInput: {
                                        queryInput: false,
                                        locationInput: false,
                                        radiusInput: false,
                                        radiusOptions: {
                                            units: "kilometres"
                                        }
                                    },
                                    prefilters: {
                                        //Filter jobs not in internal
                                        "902834a4-3efa-4ad1-98b4-ebdf7755cdbe": [`${client_cat_value}`],
                                    },
                                    searchFiltersOptions: {
                                        showResetSearchButton: true,
                                        filterShowCount: true,
                                    },
                                    searchResults: ({ results }) =>
                                        results?.length >= 1 ?
                                            <>
                                                <Row>
                                                    {results.map(({ job, index }) => (
                                                        <Col lg={6} xl={4} key={index} className="mb-4">
                                                            <JobsCard
                                                                post_lang={locale}
                                                                {...job} />
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </>
                                            : <><ld-slot name="Find a job - No results found" ></ld-slot></>
                                }
                                }
                            /> :
                            <JobSearch
                                translations={{
                                    "button.text": "Search Jobs",
                                    "input.placeHolder": "Job Title or Keyword",
                                    "input.locationPlaceholder": "enter location",
                                }}
                                options={{
                                    urlFilters: {
                                        mode: "active",
                                        jobCategories: [
                                            featuredEmployers,
                                            businessectors,
                                            jobsSector,
                                            ukjobsType,
                                            ukjobsType,
                                            jobsLocation,
                                            ukjobsWorkType,
                                            ukbasesalaryrange,
                                        ],
                                        pushToHistoryOnSearch: false,
                                        changeURLOnFilterChange: true,
                                    },
                                    jobsUrl: `${locale === "/us" ? "/us" : ""}/jobs`,
                                    jobsPerPage: 9,
                                    searchFilters: true,
                                    submitDestination: null,
                                    performInitialSearch: true,
                                    searchSubmitButton: true,
                                    searchInput: {
                                        queryInput: true,
                                        locationInput: false,
                                        radiusInput: false,
                                        radiusOptions: {
                                            units: "kilometres"
                                        }
                                    },
                                    searchFiltersOptions: {
                                        showResetSearchButton: true,
                                        topLevelCategoryOrder: ["Expertise", "Salary", "Work Type"],
                                        filterShowCount: true,
                                        exclude: {
                                            // Consultants
                                            Consultants: true,
                                            // Training and Apprenticeships
                                            "de2f2c85-d4eb-4cc4-9ce9-8b660662411a": true,
                                        },
                                        categorySort: {
                                            Expertise: { key: "name", direction: "asc" },
                                            // Job Type
                                            "94f5cb95-97ee-4c71-97ff-ed79514cabff": { key: "name", direction: "asc" },
                                            "a49a984b-60ee-4159-b8e8-acdd1433826b": function (a, b) {
                                                a = parseInt(a.name.match(/^£([\d,]+)/)[1].replace(",", ""));
                                                b = parseInt(b.name.match(/^£([\d,]+)/)[1].replace(",", ""));
                                      
                                                if (a > b) return 1;
                                                if (a < b) return -1;
                                                return 0;
                                            },
                                            "54182828-5365-45cf-ac98-4f86ec1177cd": function (a, b) {
                                                // filter out categories with no jobs
                                                if (a.parent === null) return 1;
                                                if (b.parent === null) return -1;
                                                return 0;
                                            }
                                        },
                                    },
                                    searchResults: ({ results }) =>
                                        results?.length >= 1 ?
                                            <>
                                                <Row>
                                                    {results.map(({ job, index }) => (
                                                        <Col xs={12} md={6} lg={4} key={index} className="mb-3">
                                                            <JobsCard
                                                                post_lang={locale}
                                                                {...job} />
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </>
                                            : <><ld-slot name="Find a job - No results found" ></ld-slot></>
                                }
                                }
                            />
                    }
                    <div className="newsletter mt-5 mt-md-0">
                        <div className="columnWrapper p-4 rounded-4">
                            {newsletter_content ?
                                <div className="mb-5">
                                    <SourceFlowText global={global} path={`${pathPrefix}.newsletter_content`} type="html">
                                        {newsletter_content}
                                    </SourceFlowText>
                                </div>
                                : null}
                            {formId ?
                                <Form
                                    formId={formId}
                                    onSubmitDone={() => (window.location.href = successPageUrl)}
                                /> : ""}
                        </div>
                    </div>
                </Container>
            </section>
        </>
    )
}
